import { createContext, useContext, useState, useEffect } from 'react'

const ThemeContext = createContext()

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('admin-theme') || 'light')

  useEffect(() => {
    localStorage.setItem('admin-theme', theme)
    document.body.setAttribute('data-theme', theme)
    return () => {
      document.body.removeAttribute('data-theme')
    }
  }, [theme])

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  return useContext(ThemeContext)
}